import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const updateCategoryAction = createAsyncThunk(
    'update-category',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/admins/api/update-category`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const updateCategorySlice = createSlice({
    name: 'update-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(updateCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(updateCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(updateCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const updateCategoryReducer = updateCategorySlice.reducer    